import React, { useState } from 'react';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { IExportModalProps } from './types';
import { StyledDialog, Box, Content, Footer, CloseIconStyled, CloseBox } from './styles';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { useTheme } from '@mui/material/styles';
import { OptionButton } from 'v3/shared/components/Button/OptionButton';
import { RoutesEnum } from 'v3/routes/enum';
import { saveLocalStorageData } from 'utils/saveLocalStorage';
import { CONTRACTING_PDF } from 'common/constants/contractingPdf';
import { ContractingFileTypeEnum } from 'v3/shared/enums/contracting-file-type.enum';
import { downloadOrdersExcelReport } from 'utils/excel-formatter';

export const ExportModal: React.FC<IExportModalProps> = ({ open, setOpenModal, list }) => {
  const { isMobile } = useBreakpoints();
  const [selectedFormat, setSelectedFormat] = useState<
    ContractingFileTypeEnum.XLS | ContractingFileTypeEnum.PDF | null
  >(null);
  const theme = useTheme();

  const handleExport = async () => {
    if (selectedFormat === ContractingFileTypeEnum.XLS) {
      await downloadOrdersExcelReport(list.items);
    } else if (selectedFormat === ContractingFileTypeEnum.PDF) {
      saveLocalStorageData(CONTRACTING_PDF, list.items);
      window.open(`/${RoutesEnum.ContractingPDF}`, '_blank');
    }
    setOpenModal(false);
  };

  return (
    <StyledDialog open={open} fullScreen={isMobile}>
      <Content>
        <CloseBox>
          <CloseIconStyled onClick={() => setOpenModal(false)} aria-label="Fechar modal" />
        </CloseBox>
        <HeadlineSmall color={theme.palette.common.white}>Escolha o formato do relatório</HeadlineSmall>
        <Box>
          <OptionButton
            text="PDF"
            selected={selectedFormat === ContractingFileTypeEnum.PDF}
            onClick={() => setSelectedFormat(ContractingFileTypeEnum.PDF)}
          />
          <OptionButton
            text="XLS"
            selected={selectedFormat === ContractingFileTypeEnum.XLS}
            onClick={() => setSelectedFormat(ContractingFileTypeEnum.XLS)}
          />
        </Box>
      </Content>
      <Footer>
        <FlexButton text="Exportar" size="small" handleClick={handleExport} disabled={!selectedFormat} />
        <TextButton text="Cancelar" handleClick={() => setOpenModal(false)} size="small" $outline />
      </Footer>
    </StyledDialog>
  );
};
